import querystring from "query-string";
export const REGISTRATION_TYPE = "registration_type";
export const REGISTRATION_OFFLINE = "offline";
export const OFFLINE_HASH = "hash";
export const isOfflineRegistrationVariant = () => {
    const { registration_type } = querystring.parse(window.location.search);
    return registration_type === REGISTRATION_OFFLINE;
};
export const isVerifiedOfflineAvVariant = () => {
    const { hash } = querystring.parse(window.location.search);
    return Boolean(hash && isOfflineRegistrationVariant());
};
export const isNonVerifiedOfflineAvVariant = () => isOfflineRegistrationVariant() && !isVerifiedOfflineAvVariant();
export const getIsOfflineRegistrationAvForced = () => {
    const { force_av } = querystring.parse(window.location.search);
    const isOfflineRegistration = isOfflineRegistrationVariant();
    return force_av === "true" && isOfflineRegistration;
};
export const getIsRedirectToDashboardAfterRegistration = () => {
    const { should_redirect_to_dashboard } = querystring.parse(window.location.search);
    const isOfflineRegistration = isOfflineRegistrationVariant();
    return should_redirect_to_dashboard === "true" && isOfflineRegistration;
};
export const getOfflineSourceRegisterData = () => {
    const { hash, representative_id, source_id, source_type, timestamp, registration_type } = querystring.parse(window.location.search, {});
    if (registration_type === REGISTRATION_OFFLINE) {
        return {
            hash: hash === null || hash === void 0 ? void 0 : hash.toString(),
            representative_id: (representative_id === null || representative_id === void 0 ? void 0 : representative_id.toString()) || "",
            source_id: (source_id === null || source_id === void 0 ? void 0 : source_id.toString()) || "",
            source_type: (source_type === null || source_type === void 0 ? void 0 : source_type.toString()) || "",
            timestamp: timestamp === null || timestamp === void 0 ? void 0 : timestamp.toString(),
            channel: REGISTRATION_OFFLINE,
        };
    }
    return undefined;
};
export const getOfflineTrackingRegisterData = () => {
    const { registration_type, channel_id, channel_type, country, campaign_id, content_id, guided_trial, program_id } = querystring.parse(window.location.search, {});
    const isTrackingParamExist = channel_id || channel_type || country || campaign_id || content_id || guided_trial || program_id;
    if (registration_type === REGISTRATION_OFFLINE && isTrackingParamExist) {
        return {
            channel_id: channel_id === null || channel_id === void 0 ? void 0 : channel_id.toString(),
            channel_type: channel_type === null || channel_type === void 0 ? void 0 : channel_type.toString(),
            country: country === null || country === void 0 ? void 0 : country.toString(),
            campaign_id: campaign_id === null || campaign_id === void 0 ? void 0 : campaign_id.toString(),
            content_id: content_id === null || content_id === void 0 ? void 0 : content_id.toString(),
            guided_trial: typeof guided_trial === "string" ? guided_trial === "true" : undefined,
            program_id: program_id === null || program_id === void 0 ? void 0 : program_id.toString(),
        };
    }
    return undefined;
};
//# sourceMappingURL=offlineRegistration.js.map